import { Element, Text } from 'slate';
import merge from 'lodash/merge';
import { applyDeepToNodes } from './utilities.mjs';

/**
 * Deserialize HTML to Descendant[] with marks on Text.
 * Build the leaf from the leaf deserializers of each plugin.
 */
function deserializeHTMLToMarks({
  plugins,
  element,
  children
}) {
  let leaf = {};
  plugins.forEach(({
    deserialize: pluginDeserializers
  }) => {
    if (!(pluginDeserializers != null && pluginDeserializers.leaf)) return;
    pluginDeserializers.leaf.forEach(deserializer => {
      const leafPart = deserializer.deserialize(element);
      if (!leafPart) return;
      leaf = {
        ...leaf,
        ...leafPart
      };
    });
  });
  return children.reduce((arr, child) => {
    if (!child) return arr;
    if (Element.isElement(child) || Text.isText(child)) {
      if (Object.keys(leaf).length) {
        applyDeepToNodes({
          apply: merge,
          node: child,
          source: leaf,
          filter: ([node]) => Text.isText(node)
        });
      }
      arr.push(child);
    } else if (typeof child === 'string') {
      arr.push({
        ...leaf,
        text: child
      });
    }
    return arr;
  }, []);
}

export { deserializeHTMLToMarks };
